/** The Spanish catalogue for the arrival screen — the wording only. Why each entry exists is argued in `en/boot.ts`. */
export default {
  engine: 'Motor balístico',
  starting: 'arrancando el simulador',
  warming: 'precalentando el catálogo',
  opening_room: 'abriendo la sala — esperando al plano de coordinación',
  signing_in: 'iniciando sesión — esta pestaña vuelve sola',
  connecting_local: 'conectando con la partida local',
  building_local: 'armando la partida local — {field}',
  tagline: 'Balística real · Táctica real · Airsoft real',
  files: '{done}/{total} archivos',
  failed: '{n} sin bajar',

  // ── the phases after the catalogue, which are the ones that can stall ─────────────────────────────
  connecting_field: 'conectando con el campo',
  arming_field: 'armando el campo',
  partial: 'se arranca igual — lo que falta llega después',
  local_failed: 'no se pudo armar la partida local: {err}',
  local_stalled: 'la partida local no arranca — recarga la página; si sigue, el worker no cargó',
  field_silent: 'el campo no responde — recarga la página; si sigue, el servicio no está escuchando',

  // ── LA NEGATIVA CON TACTO (`hosted.md §7.3`, T7) ──────────────────────────────────────────────────
  checking_host: 'comprobando que este equipo puede hostear — alcance y cadencia',
  unfit_title: 'Tu equipo no puede ser el anfitrión de esta partida',
  unfit_unreachable: 'tu conexión no permite conexiones directas, y ningún relevo contestó',
  unfit_slow: 'el procesador no sostiene el campo elegido ({field})',
  unfit_out: 'Puedes jugarla igual: pide a otro del grupo que la abra desde su equipo.',
  unfit_facts: 'medido · {facts}',
};
